import React from 'react';
import { useLocation, useNavigate, useParams, useResolvedPath, useSearchParams } from 'react-router-dom';

function createWithRouterWrapper(Component) {
	const Wrapped = (props) => {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const [searchParams, setSearchParams] = useSearchParams();
		const resolvedPath = useResolvedPath('.');

		const match = {
			params,
			path: location.pathname,
			url: location.pathname,
			isExact: true,
		};

		const history = {
			push: (to) => navigate(to),
			replace: (to) => navigate(to, { replace: true }),
			goBack: () => navigate(-1),
			listen: () => () => {},
		};

		return (
			<Component
				{...props}
				location={location}
				navigate={navigate}
				params={params}
				searchParams={searchParams}
				setSearchParams={setSearchParams}
				resolvedPath={resolvedPath}
				match={match}
				history={history}
			/>
		);
	};

	Wrapped.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
	return Wrapped;
}

/**
 * HOC: withRouter(Class) и декоратор класса: @withRouter class … (decorators 2023-11).
 */
export function withRouter(Component, context) {
	if (context && context.kind !== 'class') {
		return Component;
	}
	return createWithRouterWrapper(Component);
}
